import React from 'react';
import usePublicShop from '../../../../../../hooks/usePublicShop';
import PrivateShopField from './PrivateShopFields';
import PublicShopFields from './PublicShopFields';

const AdresseLivraison = () => {
  const { isPublicShop } = usePublicShop();
  if (isPublicShop) return <PublicShopFields />;
  return <PrivateShopField />;
};
export default AdresseLivraison;
